// Quando i filtri cambiano più volte di seguito, la risposta di una richiesta vecchia può arrivare dopo quella più recente
// e sostituirla con dati che non corrispondono ai filtri a video. Ogni caricamento chiede un "numero" di richiesta e,
// quando la risposta arriva, la usa solo se nel frattempo non ne è partita un'altra dello stesso tipo.
//
// Uso:
//   const attuale = this.nuovaRichiesta('kpi');
//   const res = await get_kpi_ore(filtri);
//   if (!attuale()) return;
export default {
    methods: {
        nuovaRichiesta(chiave) {
            if (!this.contatoriRichieste) this.contatoriRichieste = {};

            const numero = (this.contatoriRichieste[chiave] || 0) + 1;
            this.contatoriRichieste[chiave] = numero;

            return () => this.contatoriRichieste[chiave] === numero;
        }
    }
}
